import React from "react";
import PropTypes from "prop-types";

import WOW from "wowjs";

export default class Background extends React.Component {
	componentDidMount() {
		new WOW.WOW().init();
	}

	render() {
		return (
			<div id="my-background" className="background">
				<div id="stars" />
				<div id="stars2" />
				<div id="stars3" />
				<div className="top-container flex">
					<h1>
						Hello, I&apos;m Shubham Bharti.
						<br />
						I&apos;m a Full Stack Web Developer.
					</h1>
					{/* offset can be cahnged in node modules wowjs default file */}
					
                      <a
								href="https://drive.google.com/file/d/1iPqFeEDi-506YIfsm_clLVL2GKZnnfGW/view?usp=sharing"
								target="_blank"
								
								>
								<button
						className={"work-button " + this.props.bounceIn}
						data-wow-offset="0"
					   >
						My Resume
					</button>
					</a>

					
				</div>
			</div>
		);
	}
}

Background.propTypes = {
	aboutRef: PropTypes.object,
	bounceIn: PropTypes.string
};
